import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let edit_autopay_info = useDataValue({
    context: 'edit_autopay_info',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return {
      ...data,
      method:
        edit_autopay_info.payment_plan.autopay_source === null
          ? 'invoice'
          : 'autopay',
      autopay_source_id: edit_autopay_info.payment_plan.autopay_source,
    }
  }, [data, edit_autopay_info])
}
